import { render, staticRenderFns } from "./ApprovalConfigFilter.vue?vue&type=template&id=0af8b186&scoped=true"
import script from "./ApprovalConfigFilter.vue?vue&type=script&lang=js"
export * from "./ApprovalConfigFilter.vue?vue&type=script&lang=js"
import style0 from "./ApprovalConfigFilter.vue?vue&type=style&index=0&id=0af8b186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af8b186",
  null
  
)

export default component.exports